import {
  DbUserRole,
  dbRoleToLocalRole,
  UserStatus,
  UserRole,
  localRoleToDbRole,
  singleFileSchema,
} from 'shared';
import {z} from 'zod';

export const userSchema = z.object({
  id: z.string(),
  companyId: z.string(),
  name: z.string(),
  email: z.email(),
  phoneNumber: z.string(),
  thumbnail: z.string(),
  created: z.coerce.date(),
  modified: z.coerce.date(),
  roleId: z.enum(DbUserRole).transform<UserRole>(dbRoleToLocalRole),
  status: z.enum(UserStatus),
  invitedBy: z.string().nullable(),
});

export const userListSchema = userSchema.omit({invitedBy: true}).array();

export const editUserSchema = z.object({
  name: z.string().trim().min(2).max(30),
  phoneNumber: z.string().trim(),
  email: z.email(),
  roleId: z.enum(UserRole),
  status: z.enum(UserStatus),
  thumbnail: singleFileSchema,
});
export const editUserPayloadSchema = editUserSchema.extend({
  roleId: z.enum(UserRole).transform<DbUserRole>(localRoleToDbRole),
});

export const createUserSchema = z.object({
  emails: z.email().array().min(1),
  roleId: z.enum(UserRole),
  message: z.string(),
});
export const createUserPayloadSchema = createUserSchema.extend({
  roleId: z.enum(UserRole).transform<DbUserRole>(localRoleToDbRole),
});
